import React, { Component } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";
import _ from 'lodash' 

import { deselectAll } from "../../actions/select_actions";



import { Mutation } from "react-apollo";
import { toast } from "react-toastify";

import {
  Dialog,
  DialogType,
  DialogFooter
} from "office-ui-fabric-react/lib/Dialog";
import {
  CommandBarButton,
  PrimaryButton,
  DefaultButton
} from "office-ui-fabric-react/lib/Button";

class ShipmentDeleteButton extends Component {
  constructor() {
    super();
    this.state = {
      hideDialog: true
    };
  }

  _showDialog = () => {
    this.setState({ hideDialog: false });
  };

  _closeDialog = () => {
    this.setState({ hideDialog: true });
  };

  render() {
    const { items } = this.props;


    return (
      <div>
        <CommandBarButton
          styles={{ root: { padding: "10px" } }}
          iconProps={{ iconName: "Delete" }}
          title={`Delete ${items.length} shipments`}
          // disabled={items.length !== 0 && items[0].id !== 0 ? false : true}
          onClick={this._showDialog}
        />

        <Dialog
          hidden={this.state.hideDialog}
          onDismiss={this._closeDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Delete shipments",
            subText: "Are you sure ?"
          }}
          modalProps={{
            isBlocking: true
          }}
        >
          <Mutation
            mutation={DELETE_SHIPMENT}
            refetchQueries={["allShipments"]}
          >
            {(deleteItems, { data }) => (
              <DialogFooter>
                <PrimaryButton
                  text="Delete"
                  onClick={e => {
                    items.map(item => {
                      deleteItems({
                        variables: { id: item.id }
                      })
                        .then(response => {
                          toast.success(`Deleted !`);
                        })
                        .catch(err => {
                          toast.error(`${err}`);
                        });
                    });
                    this.props.deselectAll();
                    this._closeDialog();
                  }}
                />
                <DefaultButton onClick={this._closeDialog} text="Cancel" />
              </DialogFooter>
            )}
          </Mutation>
        </Dialog>
      </div>
    );
  }
}

const DELETE_SHIPMENT = gql`
  mutation deleteShipmentById($id: Int!) {
    deleteShipmentById(input: { id: $id }) {
      deletedShipmentId
    }
  }
`;

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(
  mapStateToProps,
  { deselectAll: deselectAll }
)(ShipmentDeleteButton);



// WEBPACK FOOTER //
// ./src/common/Buttons/_ShipmentDeleteButton.js